import React from 'react';
import classNames from 'classnames';
import './index.scss';

import OrderDatetimeControl from '../OrderDatetimeControl';
import { DATECONTROL_TYPE } from '../../../utils/enums';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon';
import {columnIsRequired} from "../../../services/filter.js";

const SectionItemDate = ({ item, value, column, onPropChange }) => {
  const handleOnSelect = date => {
    if (column.isReadonly) {
      return;
    }

    onPropChange({ [column.accessor]: date });
  };

  return (
    <div
      key={`propItem-${column.accessor}-${column.timeType || DATECONTROL_TYPE.date}`}
      className={classNames('sectionItemDate', column.inlineType, {isRequired: columnIsRequired(column, item)})}
      style={{ width: column?.width }}
    >
      <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
      <OrderDatetimeControl
        time={value || new Date().toISOString()}
        type={column.timeType || DATECONTROL_TYPE.date}
        tab={!column.timeType ? 0 : 1}
        hideIcon={true}
        hideLabel={true}
        isEditable={true}
        isReadonly={column.isReadonly}
        min={column.min ? column.min(item) : null}
        onSelect={date => handleOnSelect(date)}
        accessor={column.accessor}
      />
    </div>
  );
};

export default SectionItemDate;
